import { ErrorInRoute } from "@core/presentation/components/routing/error-in-route/error-in-route.component.tsx";
import { Route } from "react-router";

enum HomePaths {
    Home = "/",
}

export const HomeRoutes = {
    HOME: HomePaths.Home,
} as const;

export const homeRoutes = (
    <Route
        path={HomeRoutes.HOME}
        errorElement={<ErrorInRoute />}
    >
        <Route
            index
            lazy={async () => {
                const { StationResponsivePage } =
                    await import("@station/presentation/pages/station/station-responsive.page.tsx");
                return { Component: StationResponsivePage };
            }}
        />
    </Route>
);
